import React from 'react';
import type { QnAStateType } from '@uber/react-qna-lib';
import { HeadingXSmall } from 'baseui/typography';
import type { AnswerT, GenericAnnotationT } from '../../types/types';
import QuestionnairePanel from './questionnaire-panel';
type PropT = {
  questionnaireId: string;
  annotation: GenericAnnotationT;
  onQuestionnaireChange: (isAnswerValid: boolean, updatedAnswers?: AnswerT) => void;
  isQuestionnaireComposable?: boolean;
  skipHeading?: boolean;
  questionFilterFn?: (x: QnAStateType) => QnAStateType;
};
const headingOverride = {
  Block: {
    style: ({
      $theme
    }) => ({
      marginTop: $theme.sizing.scale100,
      marginBottom: $theme.sizing.scale300,
      flexGrow: '1'
    })
  }
};
const QuestionnaireSection = ({
  questionnaireId,
  annotation,
  isQuestionnaireComposable,
  onQuestionnaireChange,
  skipHeading = false,
  questionFilterFn
}: PropT) => {
  return <>
      {!skipHeading ? <HeadingXSmall overrides={headingOverride}>Questionnaire</HeadingXSmall> : null}
      <QuestionnairePanel questionnaireId={questionnaireId} answers={annotation.metadata?.answers} isQuestionnaireComposable={isQuestionnaireComposable} onChange={onQuestionnaireChange} questionFilterFn={questionFilterFn} />
    </>;
};
export default QuestionnaireSection;